<template>
  <!-- 外卖商户 -->
  <div class="takeaway">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-input placeholder="商户ID,门店ID,门店名称,备注" v-model="searchStr" size="medium" style="width: 310px"
          class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>
        </el-input>
        <el-checkbox v-model="mhYn">模糊</el-checkbox>
        <el-checkbox v-model="zcYn">非正常</el-checkbox>
      </div>
      <div class="x-flex">
        <el-button type="danger" size="medium" @click="fRegMch">增加商户</el-button>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center">
          <vxe-column field="RC" title="序号" width="50" fixed="left"></vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :width="item.width" v-for="item in tableJson"
            :key="item.title">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
              </div>
            </template>
          </vxe-column>
          <vxe-column fixed="right" title="操作" width="70" style="margin-bottom: 20px">
            <template slot-scope="scope">
              <div class="x-text-c">
                <el-button type="text" size="mini" @click="fModify(scope.row)" style="color: #2c8ff2">
                  编辑
                </el-button>
              </div>
            </template>
          </vxe-column>
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange"
          :page-size="50" :current-page="nowPage" style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="addOrEditAgent" width="600px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog">
      <div class="dialog-title x-flex x-row-between ">
        <div class="x-font-        15 f600">
          {{ takeawayAddOrEdit == "ADD" ? "增加商户" : "修改商户" }}
        </div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fSavetakeaway">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="12">
          <div class="x-w70">商户编号</div>
          <el-input :disabled="takeawayAddOrEdit != 'ADD'" class="x-flex-1" v-model="takeOutMchInfo.mch_id" size="small"></el-input>
        </el-col>
        <el-col class="x-flex" :span="12">
          <div class="x-w70">门店编号</div>
          <el-input :disabled="takeawayAddOrEdit != 'ADD'" class="x-flex-1" v-model="takeOutMchInfo.mall_id" size="small"></el-input>
        </el-col>
      </el-row>
      <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="12">
          <div class="x-w70">到期时间</div>
          <el-date-picker :disabled="!bykApi.global.fGetPlatform().partnerInfo.phone == '18957102098'" class="x-flex-1" :clearable='false' v-model="takeOutMchInfo.stop_time" type="date" size="small" value-format='yyyy-MM-dd HH:mm:ss' format='yyyy-MM-dd HH:mm:ss'
            placeholder="选择日期">
          </el-date-picker>
        </el-col>
        <el-col class="x-flex" :span="12">
          <div class="x-w70">当前状态</div>
          <el-select class="x-flex-1" size="small" v-model="takeOutMchInfo.state" placeholder="请选择">
            <el-option v-for="item in option" :key="item.val" :label="item.val" :value="item.val">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="12">
          <div class="x-w70">月费金额</div>
          <el-input class="x-flex-1" v-model="takeOutMchInfo.month_money" size="small">
            <span slot="append">元</span>
          </el-input>
        </el-col>
        <el-col class="x-flex" :span="12">
          <div class="x-w70">年费金额</div>
          <el-input class="x-flex-1" v-model="takeOutMchInfo.year_money" size="small">
            <span slot="append">元</span>
          </el-input>
        </el-col>
      </el-row> -->
      <el-row class="x-p-t-20" :gutter="20">
        <el-col class="x-flex" :span="24">
          <div class="x-w70">备注信息</div>
          <el-input class="x-flex-1" v-model="takeOutMchInfo.remark" size="small"></el-input>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        radio: "条件查询",
        searchStr: "",
        value: '',
        // uploadImgValue:'',//上传的文件名称
        mhYn: true, //
        zcYn: false, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        fileLise: [], //上传文件列表
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        state: '正常',
        ai_type: 'all',
        option: [{
          val: '正常'
        }, {
          val: '停用'
        }],
        tableJson: [{
            title: "状态",
            width: "80",
            sortType: "state",
          },
          {
            title: "商户号",
            width: "160",
            sortType: "mch_id",
          },
          {
            title: "门店号",
            width: "160",
            sortType: "mall_id",
          }, {
            // 循环渲染数据
            title: "SAAS IP",
            width: "140",
            sortType: "saas_ip",
          }, {
            // 循环渲染数据
            title: "备注信息",
            width: "200",
            sortType: "remark",
          },
          {
            title: "到期时间",
            width: "160",
            sortType: "stop_time",
          },
          {
            title: "商户类型",
            width: "200",
            sortType: "mch_type",
          },
          {
            title: "机构编码",
            width: "200",
            sortType: "org_id",
          },
          {
            title: "创建时间",
            width: "200",
            sortType: "create_time",
          },
          {
            title: "修改时间",
            width: "200",
            sortType: "chg_time",
          },
        ],
        addOrEditAgent: false, // 增加/修改用户
        takeawayAddOrEdit: "ADD",
        takeOutMchInfo: {

        },
      };
    },
    watch: {
      state() {
        this.init();
      },
      zcYn() {
        this.nowPage = 1
        this.init();
      }
    },
    created() {
      this.init();
      this.fClose()
    },
    methods: {
      async init() {
        let res = await this.fGetOrgMchMall('MALL_LIST');
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        if (this.nowPage == 1) {
          this.TR = res.page.TR || 0; //总条数
          this.TP = res.page.TP || 0; //总页数
        }
        this.tableData = res.data;
      },

      async fModify(row) {
        this.takeawayAddOrEdit = "EDIT";
        this.fileLise = []
        this.addOrEditAgent = true;
        // let res = await this.fMchAiManger(
        //   "GET",
        //   row.org_id
        // );
        // console.log(row.org_id)

        // if (res.result != "sucess") {
        //   return this.$message(res.msg);
        // }
        this.takeOutMchInfo.org_id = row.org_id;
        this.takeOutMchInfo.mch_id = row.mch_id;
        this.takeOutMchInfo.mch_type = row.mch_type;
        this.takeOutMchInfo.mall_id = row.mall_id;
        // this.takeOutMchInfo.pro_fee = row.pro_fee;
        // if (this.bykApi.smCom.fSmIsEmpty(row.pro_fee)) {
        //   this.takeOutMchInfo.month_money = '0'
        //   this.takeOutMchInfo.year_money = '0'
        // } else {
        //   let proFee = JSON.parse(row.pro_fee)
        //   console.log(proFee)
        //   proFee.forEach((item,index)=>{
        //     if(item.day == '30'){
        //       console.log(item.fee )
        //       this.takeOutMchInfo.month_money = item.fee
        //     }
        //     if(item.day == '365'){
        //       this.takeOutMchInfo.year_money = item.fee
        //     }
        //   })
        //   // this.takeOutMchInfo.month_money = proFee.month || ''
        //   // this.takeOutMchInfo.year_money = proFee.year || ''
        // }
        // this.takeOutMchInfo.pro_fee = row.pro_fee;
        this.takeOutMchInfo.stop_time = row.stop_time;
        this.takeOutMchInfo.remark = row.remark;
        this.takeOutMchInfo.state = row.state;

      },
      // 解绑
      // async unBand(row) {
      //   this.$confirm('是否确认解绑', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     confirmButtonClass: 'confirmButton',
      //   }).then(async () => {
      //     let res = await this.fOrgMchMall('UN_BAND', row)
      //     if (res.result != 'sucess') {
      //       return this.$message(res.msg)
      //     }
      //     this.$message(res.msg)
      //     this.init()
      //   }).catch(() => {});
      // },
      async fSavetakeaway() {
        if (this.bykApi.smCom.fSmIsEmpty(this.takeOutMchInfo.mch_id)) {
          return this.$message("商户编号不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.takeOutMchInfo.mall_id)) {
          return this.$message("门店编号不能为空");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.takeOutMchInfo.mall_id)) {
          return this.$message("门店编号不能为空");
        }


        // return
        let res = await this.fOrgMchMall(this.takeawayAddOrEdit);
        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        if (this.takeawayAddOrEdit == 'ADD') {
          this.$message(res.msg);
        } else {
          this.$message('修改成功');
        }
        this.init();
        this.fClose();
      },
      fClose() {
        this.addOrEditAgent = false;
        this.fileLise = []
        this.takeOutMchInfo = Object.assign({
          org_id: '',
          mch_id: '',
          mch_type: '',
          mall_id: '00010001',
          pro_fee: '',
          stop_time: this.bykApi.timeHelper.manyDaysLater(365, 3) + ' 00:00:00',
          remark: '',
          // month_money: '59',
          // year_money: '299',
          state: '正常',
        });
      },
      // 排序
      async fHeadSort(type, asc_desc = "") {
        // console.log(this.sortType, type);
        // console.log(type, asc_desc);
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        this.init();
      },

      fRegMch() {
        this.takeawayAddOrEdit = "ADD";
        this.addOrEditAgent = true;
        this.fileLise = []
      },
      // 分页
      async fCurrentChange(e) {
        this.nowPage = e
        let res = await this.fGetOrgMchMall('MALL_LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },


      // ------------- 请求 开始 --------------
      async fGetOrgMchMall(oper) {
        let js = {};
        js["OPER"] = oper; // 必填 MALL_LIST MALL_ID
        // MALL_LIST
        js['STATE'] = this.zcYn ? '停用': this.state
        js['SEARCH_STR'] = this.searchStr
        js['NOW_PAGE'] = this.nowPage
        js['PAGE_SIZE'] = 50
        js['ORDER_BY'] = ''
        js['MH_YN'] = this.mhYn ? "Y" : "N"
        // MALL_ID
        js["MCH_TYPE"] = 'smSell'; // 必填 商户类型 如smSell
        js['ORG_ID'] = this.takeOutMchInfo.org_id
        js['MCH_ID'] = this.takeOutMchInfo.mch_id
        js['MALL_ID'] = this.takeOutMchInfo.mch_name
        // js['USER_MEMO'] = this.takeOutMchInfo.user_memo
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmTakeOutTkQryApi("GET_ORG_MCH_MALL", js);
        console.log(res)
        return res;
      },
      async fOrgMchMall(oper) {
        let js = {};
        js["OPER"] = oper; // 必填 ADD EDIT DEL
        js["MCH_TYPE"] = this.takeOutMchInfo.mch_type || 'smSell'; // 必填 商户类型 如smSell
        js["ORG_ID"] = 'SmCloud'; // 必填 租户编码 尚米云为SmCloud
        js["MCH_ID"] = this.takeOutMchInfo.mch_id; // 必填 saas商户号
        js["MALL_ID"] = this.takeOutMchInfo.mall_id; // 必填 saas门店id
        // let proFee = [{
        //   "day": "30",
        //   "fee": this.takeOutMchInfo.month_money,
        //   "label": "包月"
        // }, {
        //   "day": "365",
        //   "fee": this.takeOutMchInfo.year_money,
        //   "label": "包年"
        // }]
        // // {
        // //   month: this.takeOutMchInfo.month_money || 0,
        // //   year: this.takeOutMchInfo.year_money || 0
        // // }
        // js["PRO_FEE"] = JSON.stringify(proFee); // 产品费用json
        js["STOP_TIME"] = this.takeOutMchInfo.stop_time; // 到期时间
        js["REMARK"] = this.takeOutMchInfo.remark; // 备注
        js["STATE"] = this.takeOutMchInfo.state; // 状态
        js["CHG_USER_NAME"] = JSON.parse(localStorage.getItem("bykPlatform")).partnerInfo.data.user_name; // 修改人
        console.log(js)
        let res = await this.bykApi.postApi.fPostToSmTakeOutTkAdminApi("ORG_MCH_MALL", js);
        console.log(res)
        return res;
      },


      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .takeaway {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }

  /* .x-w66{} */
  .must1 {
    position: relative;
  }

  .must1:after {
    position: absolute;
    top: -4px;
    right: 2px;
    content: '*';
    color: red;
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/view/takeaway.vue